import React, {useState} from "react";
import "../../styles/components/anwenderListComponent.css";
import AuswertungFilter from "./AuswertungFilter";

const initialFilterProps = {
    vorname: "",
    name: "",
    organisation: "",
    statusBeantragt: true,
    statusBestaetigt: true,
    statusAktiv: true,
    statusInaktiv: true,
    rolleOrganisation: true,
    rolleBehoerde: true,
    rolleAdministration: true
};

function AuswertungComponent() {
    const [volatileFilterProps, setVolatileFilterProps] = useState(initialFilterProps);

    function handleFilterChange(fieldName, newVal) {
        setVolatileFilterProps({...volatileFilterProps, [fieldName]: newVal});
    }

    return (
        <div className="gridl anwenderListComponent tabsheet-content-margin">
            <AuswertungFilter
                filterProps={volatileFilterProps}
                onFilterPropsChange={handleFilterChange}
                onFilterReset={() => setVolatileFilterProps(initialFilterProps)}
            />
        </div>
    );
}

export default AuswertungComponent;
